import React from 'react';
import { useLocation } from 'react-router-dom';
import { Link, useIdioma } from '../i18n';
import '../styles/NotFound.css';

/**
 * Página para caminhos que não correspondem a nenhuma rota.
 *
 * Sem ela, o React Router não renderizava nada e o usuário via uma tela em
 * branco — indistinguível de uma falha de carregamento. Isso acontecia com
 * qualquer URL digitada errada e com links internos apontando para telas que
 * não existem, como os que o menu tinha até há pouco.
 */
const NotFound = ({ user }) => {
  const { t } = useIdioma();
  const location = useLocation();

  return (
    <main className="not-found">
      <div className="not-found-box">
        <p className="not-found-code">404</p>
        <h1>{t('naoEncontrada.titulo')}</h1>

        <p className="not-found-path">
          <code>{location.pathname}</code>
        </p>

        <p className="not-found-help">{t('naoEncontrada.ajuda')}</p>

        <div className="not-found-actions">
          {/* O destino depende de haver sessão: mandar um visitante para
              /user-home só produziria outro redirecionamento. */}
          <Link to={user ? '/user-home' : '/'} className="not-found-primary">
            {t(user ? 'naoEncontrada.paraPainel' : 'naoEncontrada.paraHome')}
          </Link>

          {user && (
            <Link to="/projects" className="not-found-secondary">
              {t('naoEncontrada.meusProjetos')}
            </Link>
          )}
        </div>
      </div>
    </main>
  );
};

export default NotFound;
